import { CalendarUI } from './ui';

export const CalendarPage = () => {
  return <CalendarUI />;
};

export default CalendarPage;

